import React, { forwardRef } from 'react';
import { Button, Stack } from '@mui/material';
import EmptyContent from '@/components/@IntranetLibrary/EmptyContent';
import { Body1 } from '@/components/@IntranetLibrary/Typography';
import { t } from 'i18next';
import CommentItem, {
  CommentItemProps,
} from '@/components/Comment/CommentList/CommentItem';
import { CommentInputRef } from '@/components/Comment/CommentInput';

export type CommentListProps = Pick<
  CommentItemProps,
  | 'onChanged'
  | 'isMobile'
  | 'inputStyle'
  | 'service'
  | 'beforeSubmit'
  | 'checkIsText'
> & {
  list: CommentItemProps['item'][];
  hasNextPage: boolean;
  nextPageButtonOnClick?: () => void;
  isEmpty: boolean;
  leftCount: number;
};

const CommentList = forwardRef<CommentInputRef, CommentListProps>(
  (props, ref) => {
    const {
      list,
      hasNextPage,
      nextPageButtonOnClick,
      isEmpty,
      leftCount,
      inputStyle,
      ...commentItemElemProps
    } = props;

    return (
      <Stack
        direction={'column'}
        gap={'24px'}
        sx={{
          flex: isEmpty ? 1 : 'initial',
          justifyContent: isEmpty ? 'center' : 'initial',
        }}
      >
        {isEmpty && (
          <EmptyContent
            title={
              <>
                {t('작성된 코멘트가 없어요.')}
                <br />
                {t('첫번째 코멘트를 남겨보세요!')}
              </>
            }
            sx={{
              margin: '44px auto 72px',
              padding: inputStyle === 'mobile' ? '20px 0' : 0,
            }}
          />
        )}
        {list.map((item) => {
          return (
            <CommentItem
              key={item.id}
              item={item}
              ref={ref}
              inputStyle={inputStyle}
              {...commentItemElemProps}
            />
          );
        })}
        {hasNextPage && (
          <Button
            disableRipple={true}
            sx={{
              padding: 0,
              display: 'block',
              textAlign: 'left',
            }}
            onClick={nextPageButtonOnClick}
          >
            <Body1
              sx={{
                color: 'var(--dk-accent, #06C)',
                fontWeight: 400,
              }}
            >
              이전 코멘트 {leftCount}개 더보기
            </Body1>
          </Button>
        )}
      </Stack>
    );
  },
);
CommentList.displayName = 'CommentList';

export default CommentList;
